// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XuV7","question":"styles_question__2BNFV","inputVisibleButton":"styles_inputVisibleButton__hgxP3","note":"styles_note__2rSmV"};